module.exports = __webpack_public_path__ + "img/logoMobily.8d0beee3.svg";